<template>
  <div style="position: relative;" :class="classe[0]">
    <div class="d-flex">
      <FormulateInput
        :name="name"
        type="text"
        :label="currentLabel || label"
        :validation="(currentValidation || validation) ? (currentValidation || validation).split('|').map(p=>p.trim()).filter(p=>!p.startsWith('matches:')).join('|') : ''"
        :errors="campoValido ? [] : ( (currentValidation || validation || '').includes('matches:') && textoDigitado ? [ (currentLabel || label) + ' não é um valor válido.' ] : null )"
        :placeholder="placeholder"
        :class="this.$props.classe[1] + ' col-10 pa-0'"
        v-model="textoDigitado"
        v-if="maskConfig"
        v-mask="maskConfig"
        :disabled="isDisabled"
        :readonly="readonly"
        @input="aoDigitar"
        style="margin-bottom: 0px !important;"
        autocomplete="off"
      />
      <FormulateInput
        :name="name"
        type="text"
        :label="currentLabel || label"
        :validation="(currentValidation || validation) ? (currentValidation || validation).split('|').map(p=>p.trim()).filter(p=>!p.startsWith('matches:')).join('|') : ''"
        :errors="campoValido ? [] : ( (currentValidation || validation || '').includes('matches:') && textoDigitado ? [ (currentLabel || label) + ' não é um valor válido.' ] : null )"
        :placeholder="placeholder"
        :class="this.$props.classe[1] + ' col-10 pa-0'"
        v-model="textoDigitado"
        v-else
        :disabled="isDisabled"
        :readonly="readonly"
        @input="aoDigitar"
        style="margin-bottom: 0px !important;"
        autocomplete="off"
      />
      <div class="col-2 pa-1 d-flex flex-column justify-end">
        <SGPIconComponent
          :icon="campoValido ? 'mdi-check-circle' : 'mdi-close-circle'"
          :color="campoValido ? '#198754' : '#df323b'"
          v-if="!isDisabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextMaskDependentComponent",

  props: {
    configInput: {
      type: Object,
      required: true
    },
    parameters: {
      type: Object,
      required: false
    },
    value: {
      type: [Object, String],
      required: false
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    validation: {
      type: String,
      required: false,
      default: ""
    },
    classe: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      textoDigitado: '',
      currentMask: null,
      currentLabel: null,
      currentValidation: null,
      campoValido: false,
      dependentFieldValue: null
    }
  },

  watch: {
    value: {
      handler(newValue) {
        if (newValue !== this.textoDigitado && this.shouldSyncFromParent) {
          this.textoDigitado = newValue || '';
        }
      },
      immediate: true
    },
    
    parameters: {
      handler() {
        this.updateMaskBasedOnDependencies();
      },
      deep: true,
      immediate: true
    },
  },

  mounted() {
    this.updateMaskBasedOnDependencies();
    if (!this.configInput.dependsOn) {
      this.currentMask = this.configInput.mask || null;
      this.currentLabel = this.label;
      this.currentValidation = this.validation;
    }
  },

  computed: {
    isDisabled() {
      if (this.configInput.dependsOn?.field) {
        const dependentValue = this.getValueByPath(this.parameters, this.configInput.dependsOn.field);
        return !dependentValue || this.readonly;
      }
      return this.readonly;
    },

    maskConfig() {
        if (!this.currentMask) return null;

        const dynamicMaskMatch = this.currentMask.match(/^([*#])\{(\d+),(\d+)\}$/);
        if (dynamicMaskMatch) {
          const tipo = dynamicMaskMatch[1];
          return {
            mask: tipo.repeat(parseInt(dynamicMaskMatch[3], 10)), // repete até o máximo
            tokens: {
              '*': { pattern: /[A-Za-z0-9]/ },
              '#': { pattern: /[0-9]/ }
            }
          };
        }

        if (this.currentMask && this.currentMask.includes('*')) {
            return {
                mask: this.currentMask,
                tokens: { '*': { pattern: /[A-Za-z0-9]/ } }
            }
        }

        if (this.currentMask && this.currentMask.includes('#')) {
            return {
                mask: this.currentMask,
                tokens: { '#': { pattern: /[0-9]/ } }
            }
        }
        return this.currentMask;
    },
  },

  methods: {
    aoDigitar(valor) {
      const dynamicMaskMatch = this.currentMask && this.currentMask.match(/^([*#])\{(\d+),(\d+)\}$/);
      if (dynamicMaskMatch) {
        const tipo = dynamicMaskMatch[1];
        const max = parseInt(dynamicMaskMatch[3], 10);

        let novoValor = valor;
        if (tipo === '*') {
          novoValor = novoValor.replace(/[^A-Za-z0-9]/g, '');
        } else if (tipo === '#') {
          novoValor = novoValor.replace(/[^0-9]/g, '');
        }
        novoValor = novoValor.slice(0, max);

        this.textoDigitado = novoValor;
        valor = novoValor;
      } else if (this.currentMask) {
        const prefixMatch = this.currentMask.match(/^([^*#]+)/);
        if (prefixMatch && prefixMatch[1] !== '') {
          const prefix = prefixMatch[1];

          if (
            valor.length < prefix.length ||
            !valor.startsWith(prefix)
          ) {
            this.textoDigitado = prefix;
            return;
          }

          let rest = valor.slice(prefix.length);
          rest = rest.replace(new RegExp(prefix, 'g'), '');
          rest = rest.replace(/[^A-Za-z0-9]/g, '');
          const maxSufixo = this.currentMask.length - prefix.length;
          rest = rest.slice(0, maxSufixo);

          const result = prefix + rest;
          if (result !== valor) {
            this.textoDigitado = result;
            valor = result;
          }
        }
      } else {
        this.textoDigitado = valor;
      }
      
      this.validarCampo(valor);

      if (this.campoValido) {
        if (valor !== this.value) {
          this.$emit('update', [
            { name: this.name, model: valor }
          ]);
        }
      } else {
        this.$emit('update', [
          { name: this.name, model: '' }
        ]);
      }
    },

    checkRequiredParameters() {
      if (!this.configInput.dependsOn?.requiredParameters || !this.parameters) {
        return true;
      }
      return this.configInput.dependsOn.requiredParameters.every(param => {
        const value = this.getValueByPath(this.parameters, param.path);
        return value !== undefined && value !== null && value !== '';
      });
    },

    updateMaskBasedOnDependencies() {
      if (!this.configInput.dependsOn) {
        this.currentMask = this.configInput.mask || null;
        this.currentLabel = this.label;
        this.currentValidation = this.validation;
        return;
      }

      const dependentField = this.configInput.dependsOn.field;
      const dependentValue = this.getValueByPath(this.parameters, dependentField);
      
      if (dependentValue !== this.dependentFieldValue) {
        this.dependentFieldValue = dependentValue;
        this.applyRuleBasedOnDependentValue(dependentValue);
      }
    },
    
    applyRuleBasedOnDependentValue(dependentValue) {
      if (!this.configInput.dependsOn?.rules) return;

      const rule = this.configInput.dependsOn.rules.find(r => r.value === dependentValue);

      if (rule) {
        this.currentMask = rule.mask;
        this.currentLabel = rule.label || this.label;
        this.currentValidation = rule.validation || this.validation;

        this.$nextTick(() => {
          this.textoDigitado = '';
          this.$emit('update', [
            { name: this.name, model: '' }
          ]);
          if (this.currentMask) {
            const prefixMatch = this.currentMask.match(/^([^*#]+)/);
            if (prefixMatch && prefixMatch[1] !== '') {
              this.textoDigitado = prefixMatch[1];
            }
          }
          this.validarCampo(this.textoDigitado);
        });
      } else {
        this.currentMask = '';
        this.currentLabel = this.label;
        this.currentValidation = this.validation;
        this.campoValido = false;
      }
    },
    
    getValueByPath(obj, path) {
      if (!obj || !path) return '';
      
      const result = path.split('.').reduce((acc, key) => {
        if (Array.isArray(acc)) {
          return acc.map(item => item[key]).filter(v => v !== undefined);
        }
        return acc && acc[key];
      }, obj);

      if (Array.isArray(result)) {
        return result.filter(v => v !== undefined && v !== null).join(', ');
      }

      return result !== undefined && result !== null ? String(result) : '';
    },
    
    validarCampo(valor) {
      const v = valor !== undefined && valor !== null ? String(valor).trim() : '';
      
      let min = null;
      const dynamicMaskMatch = this.currentMask && this.currentMask.match(/^([*#])\{(\d+),(\d+)\}$/);
      
      if (dynamicMaskMatch) {
        min = parseInt(dynamicMaskMatch[2], 10);
      }

      if (!v) {
        this.campoValido = false;
        return;
      }

      if (min && v.length < min) {
        this.campoValido = false;
        return;
      }
      
      if (!this.currentValidation) {
        this.campoValido = true;
        return;
      }
      
      if (this.currentValidation.includes('matches:')) {
        const regexMatch = this.currentValidation.match(/matches:\/([\s\S]+?)\/([gimuy]*)/);
        if (regexMatch && regexMatch[1]) {
          const pattern = regexMatch[1];
          const flags = regexMatch[2] || '';
          const regex = new RegExp(pattern, flags);
          this.campoValido = regex.test(v);
          return;
        }
      } 
      
      this.campoValido = !(this.currentValidation.includes('required') && !valor);
      
    }
  }
}
</script>

<style scoped>

</style>